<template>
  <v-row>
    <v-col cols="12">
      <gg-card-title>
        Migration Details
        <router-link class="body-2 pl-md-2" :to="{ name: 'migrations' }">
          Back to migrations list
        </router-link>
      </gg-card-title>
    </v-col>
    <v-col v-if="loading && !migration" cols="12">
      <div class="flex justify-center pt-4">
        <v-progress-circular indeterminate size="64" color="primary" />
      </div>
    </v-col>
    <v-col v-if="migration" cols="12">
      <migration-details-card :migration="migration" />
    </v-col>
    <v-col v-if="hasSubaccounts" cols="12">
      <sub-migrations-card :sub-migrations="migration.subaccounts" />
    </v-col>
    <v-col v-if="migration && migration.can_early_start" cols="12">
      <migration-start-card :migration="migration" @get-migration-data="getMigrationDetails" />
    </v-col>
    <v-col v-if="migration && migration.messages.length" cols="12">
      <h2 class="py-3">Messages</h2>
      <migration-messages-card :migration="migration" />
    </v-col>
  </v-row>
</template>

<script>
import debounce from 'lodash.debounce'
import { mapActions } from 'vuex'
import MigrationDetailsCard from '@/components/Migrations/MigrationDetailsCard'
import MigrationMessagesCard from '@/components/Migrations/MigrationMessagesCard'
import MigrationStartCard from '@/components/Migrations/MigrationStartCard'
import SubMigrationsCard from '@/components/Migrations/SubMigrationsCard'

export default {
  name: 'MigrationDetails',
  components: {
    MigrationDetailsCard,
    MigrationMessagesCard,
    MigrationStartCard,
    SubMigrationsCard,
  },
  data () {
    return {
      loading: true,
      migration: null,
      timer: null
    }
  },
  computed: {
    hasSubaccounts () {
      return Array.isArray(this.migration.subaccounts) && this.migration.subaccounts.length > 0
    }
  },
  methods: {
    ...mapActions({
      reportError: 'reportError',
      getMigration: 'migrations/getMigration',
    }),
    getMigrationDetails: debounce(async function () {
      const id = this.$route.params.id
      this.loading = true
      try {
        this.migration = await this.getMigration(id, true)
      } catch (e) {
        this.reportError(e)
        this.$router.push({ name: 'migrations' })
      } finally {
        this.loading = false
      }
    }, 5000, { leading: true }),
    startMigrationTimer () {
      this.getMigrationDetails()
      this.timer = setInterval(() => {
        this.getMigrationDetails()
      }, 15000)
    },
  },
  mounted () {
    this.migration = null
    this.timer = null
    this.startMigrationTimer()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
